<script setup lang="ts">
import AuSkeletonWrapper from '~/components/ui/AuSkeletonWrapper.vue'
import AuSkeleton from '~/components/ui/AuSkeleton.vue'
</script>

<template>
  <AuSkeletonWrapper>
    <AuSkeleton
      width="100%"
      height="1px"
      class="!block"
    />
    <ul class="grid auto-rows-max grid-cols-2 gap-x-4 gap-y-8 lg:grid-cols-3 xl:grid-cols-4">
      <li
        v-for="i in 16"
        :key="i"
        class="flex flex-col gap-3 p-4"
      >
        <AuSkeleton
          height="256px"
          class="!rounded-none"
        />
        <AuSkeleton
          height="20px"
          width="45%"
          class="!rounded-none"
        />
        <AuSkeleton
          height="30px"
          width="90%"
          class="!rounded-none"
        />
        <AuSkeleton
          height="25px"
          width="30px"
          class="!rounded-none"
        />
      </li>
    </ul>
  </AuSkeletonWrapper>
</template>
